import { render, staticRenderFns } from "./DoorDescription.vue?vue&type=template&id=b24bb248&scoped=true"
import script from "./DoorDescription.vue?vue&type=script&lang=ts"
export * from "./DoorDescription.vue?vue&type=script&lang=ts"
import style0 from "./DoorDescription.vue?vue&type=style&index=0&id=b24bb248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24bb248",
  null
  
)

export default component.exports